import { Desktop, Mobile } from '../../../components/media'

export default function InstalledOptionPackages({ installedOptionPackages }) {
  console.log(installedOptionPackages)

  return (
    <>
      <div className='wrapper'>
        <div className='line flex justifyBetween'>
          <div className='item flex'>
            {!!installedOptionPackages && installedOptionPackages.length > 0 ? (
              <>
                <div className='title'></div>
                <Desktop>
                  <div className='value alone'>
                    <ul>
                      {installedOptionPackages.map((entry, i) => (
                        <li key={entry}>{entry}</li>
                      ))}
                    </ul>
                  </div>
                </Desktop>

                <Mobile>
                  <div className='value'>
                    <ul>
                      {installedOptionPackages.map((entry) => (
                        <li key={entry}>{entry}</li>
                      ))}
                    </ul>
                  </div>
                </Mobile>
              </>
            ) : (
              <div className='title'>No Information Provided</div>
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        .wrapper,
        .item {
          width: 100%;
        }

        .line {
          padding: 1.95rem 0 2.75rem;
          width: 100%;
          border-bottom: 1px solid var(--secondary-input-bg);

          &.line:last-child {
            border-bottom: 0;
          }
        }

        .title {
          flex: 6;
          color: var(--secondary-text-color);
          word-wrap: break-word;
          line-height: 2.4rem;
          font-size: 1.8rem;
        }

        .value {
          flex: 11;
          line-height: 2.4rem;
          font-size: 1.8rem;
          font-weight: 700;

          &:last-child {
            flex: 10;
          }

          ul {
            padding-inline-start: 4rem;

            li {
              list-style-type: disc;
              padding: 0 0 1.4rem;
            }
          }

          &.alone {
            flex: 20;
            padding: 0 0 1.4rem 4.1rem;
          }
        }

        @media (min-width: 1025px) and (max-width: 1364px) {
          .title,
          .value {
            line-height: 1.9rem;
            font-size: 1.4rem;
          }

          .line {
            padding: 1.85rem 0 0;
          }
        }

        @media (max-width: 1024px) {
          .flex {
            flex-direction: column;
          }

          .title {
            line-height: 1.9rem;
            font-size: 1.4rem;
          }

          .value {
            padding: 2rem 0 0;
            line-height: 1.9rem;
            font-size: 1.4rem;
            font-weight: 700;

            ul > li {
              list-style-type: disc;
              padding: 0 0 1.4rem;
            }
          }
        }
      `}</style>
    </>
  )
}
